// Shows "Order within Xh Ym" until today's dispatch cut-off in the store's time zone, hidden after it.
// shortcut: ignores weekends and holidays, add a closed-days setting if the store doesn't dispatch every day.
if (!customElements.get('dispatch-countdown')) {
  customElements.define(
    'dispatch-countdown',
    class DispatchCountdown extends HTMLElement {
      connectedCallback() {
        this.update();
        this.timer = setInterval(() => this.update(), 60000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      update() {
        let minutesLeft = 0;
        try {
          const parts = new Intl.DateTimeFormat('en-GB', {
            timeZone: this.dataset.timezone || undefined,
            hour: 'numeric',
            minute: 'numeric',
            hourCycle: 'h23',
          }).formatToParts(new Date());
          const get = (type) => Number(parts.find((part) => part.type === type).value);
          minutesLeft = Number(this.dataset.cutoff) * 60 - (get('hour') * 60 + get('minute'));
        } catch (error) {
          minutesLeft = 0; // invalid time zone setting
        }

        this.hidden = minutesLeft <= 0;
        if (minutesLeft <= 0) return;
        this.querySelector('[data-time]').textContent = this.dataset.format
          .replace('[h]', Math.floor(minutesLeft / 60))
          .replace('[m]', minutesLeft % 60);
      }
    }
  );
}
